import React from 'react'
import { Select, SelectProps, MenuItem, makeStyles } from '@material-ui/core'
import { useLocalization } from 'components/methods'
import { Color, FontSize, FontWeight, Value } from 'theme/style'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    position: 'relative',
  },
  placeholder: {
    ...theme.typography.body2,
    position: 'absolute',
    zIndex: 99,
    width: '100%',
    paddingLeft: theme.spacing(1.5),
    pointerEvents: 'none',
    textAlign: 'left',
    fontSize: FontSize.Body2,
    color: Color.TextLight,
    fontWeight: FontWeight.Medium,
  },
  input: {
    flex: 1,
    textAlign: 'left',
    padding: theme.spacing(0, 1.5),
    height: '45px',
    backgroundColor: Color.Background,
    // border: '2px solid transparent',
    // borderColor: '#E8E8E8',
    borderRadius: Value.BorderRadius_Field,
    '& >div': {
      width: '100% !important',
      paddingLeft: 0,
      padding: theme.spacing(0),
      textAlign: 'left',
      fontSize: FontSize.Body2,
      color: Color.TextPrimary,
      fontWeight: FontWeight.SemiBold,
      '&::placeholder': {
        color: Color.TextLight,
        fontWeight: FontWeight.Medium,
      }
    },
    '& >svg': {
      right: '10px'
    }
  },
  empty: {
    fontStyle: 'italic',
    color: Color.TextSecondary
  }
}))

interface SelectFieldProps extends SelectProps {
  async?: boolean
  enableClear?: boolean
  clearText?: string
  placeholder?: string
  onUpdate?: (name: string, value: any) => void
  onConfirm?: (name: string, value: any) => void
}

const SelectField = ({ ...props }: SelectFieldProps) => {
  const classes = useStyles()
  const { t } = useLocalization()


  //FIELD CHANGES

  function updateField(event: any) {
    const target = event.target as HTMLInputElement
    const name = target.name as string
    const value = target.value

    if (props.onUpdate == null) return
    props.onUpdate(name, value)
  }



  //EVENTS

  function remove() {
    if (props.name == null) return
    if (props.onUpdate != null) props.onUpdate(props.name, null)
  }


  //RENDER

  return (
    <div className={classes.container}>
      {props.placeholder != null && props.value == null && <div className={classes.placeholder}>{props.placeholder}</div>}
      <Select {...props} disableUnderline className={classes.input} onChange={updateField}>
        {props.enableClear === true && <MenuItem key={'empty-value'} value={undefined} onClick={remove}><span className={classes.empty}>{props.clearText ?? t('GEL.whitelabel.common.field.select.no-option')}</span></MenuItem>}
        {props.children}
      </Select>
    </div>
  )
}

export default SelectField
